import { useEffect, useSyncExternalStore } from 'react';

/* 铃的珍藏（2026-10-16）：纸上夹一枚丝带书签 = 收藏这条记忆/日记。
   存在大脑（/api/favs），手机电脑同一份；大脑那边也会悄悄告诉他「她收藏了你写的这篇」。
   记忆页和时间页共用这一份（模块级小仓库，谁改了大家一起刷新）。 */
let ids = new Set();
let loading = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());

function subscribe(f) {
  subs.add(f);
  return () => subs.delete(f);
}
const snapshot = () => ids;

export function loadFavs() {
  if (!loading) {
    loading = fetch('/api/favs', { credentials: 'include', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
      .then((d) => {
        ids = new Set(Array.isArray(d.ids) ? d.ids : []);
        emit();
      })
      .catch(() => {
        loading = null; // 下次再试
      });
  }
  return loading;
}

export function useFavs() {
  useEffect(() => {
    loadFavs();
  }, []);
  return useSyncExternalStore(subscribe, snapshot);
}

// 先在页面上夹上（不等网），大脑没存住再取下来
export async function toggleFav(id) {
  const on = !ids.has(id);
  const set = (v) => {
    ids = new Set(ids);
    if (v) ids.add(id);
    else ids.delete(id);
    emit();
  };
  set(on);
  try {
    const r = await fetch('/api/fav', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, on }),
    });
    if (!r.ok) throw new Error('HTTP ' + r.status);
  } catch {
    set(!on);
  }
  return on;
}
